import { render, staticRenderFns } from "./PtButton.vue?vue&type=template&id=2548d23a&scoped=true&lang=pug"
import script from "./PtButton.vue?vue&type=script&lang=js"
export * from "./PtButton.vue?vue&type=script&lang=js"
import style0 from "./PtButton.vue?vue&type=style&index=0&id=2548d23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548d23a",
  null
  
)

export default component.exports